"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activityIndicatorVariantProps = exports.activityIndicatorCommonProps = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * PropTypes for the 3 variants of the ActivityIndicator:
 *   - InlineIndicator
 *   - OverlayIndicator
 *   - FullScreenIndicator
 */
const activityIndicatorVariantProps = exports.activityIndicatorVariantProps = _propTypes.default.shape({
  /**
   * Indicates the variant style for the ActivityIndicator
   * */
  variant: _propTypes.default.object,
  /**
   * Size of the dots
   * */
  dotSize: _propTypes.default.number,
  /**
   * Size of the ActivityIndicator Spinner
   * */
  size: _propTypes.default.number,
  /**
   * Primary color (Spinner)
   * */
  color: _propTypes.default.string,
  /**
   * Secondary color (background) of the indicator
   * */
  indicatorBackgroundColor: _propTypes.default.string,
  /**
   * Thickness of the ActivityIndicator Spinner
   * */
  thickness: _propTypes.default.number,
  /**
   * Indicates if the ActivityIndicator is static
   * (not animated)
   * */
  isStatic: _propTypes.default.bool
}).isRequired;
const activityIndicatorCommonProps = exports.activityIndicatorCommonProps = {
  /**
   * Props used by RenderActivityIndicator
   * */
  variantProps: activityIndicatorVariantProps,
  /**
   * Shows or hide the label
   * */
  showLabel: _propTypes.default.bool,
  /**
   * A visually hidden accessible label describing the action taking place
   */
  label: _propTypes.default.string,
  /**
   * Position of the label relative to ActivityIndicator
   */
  labelPosition: _propTypes.default.oneOf(['top', 'bottom', 'left', 'right']),
  /**
   * Map of flex-direction position for label
   * */
  labelMapping: _propTypes.default.object.isRequired
};